// AuthGate.jsx
import { useContext, useEffect, useState } from "react";
import { serverURL } from "../utils";
import { DataContext } from "../DataContext";
import { IconLogo } from "../svgs";
import styled from "styled-components";

const Maintenance = styled.div`
  min-height: 100svh;
  background: #53555a;
  .maintenance-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img.maintenance-logo {
      width: 80px;
    }
    h2 {
      font-size: 16px;
      color: #97a3ae;
    }
    form {
      display: flex;
      gap: 8px;
    }
    input {
      padding: 4px 8px;
      font-size: 12px;
      border-radius: 5px;
      border: none;
      background-color: #53555a;
      cursor: default;
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
`;

const MaintenanceButton = styled.div`
    button.maintenance-logout {
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;
      border: 0;
      font-size: 12px;
      line-height: 24px;
      text-transform: uppercase;
      padding: 10px;
      z-index: 1000;
      background-color: #666666;
      color: #ffffff;
      font-weight: 700;
      -webkit-font-smoothing: antialiased;
    }
  }
`;

export default function AuthGate({ children }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [passcode, setPasscode] = useState("");

  const { settings } = useContext(DataContext);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${serverURL()}/passcode/auth/check`, {
          credentials: "include",
        });
        const data = await res.json();
        setAuthorized(Boolean(data.ok));
      } catch {
        setAuthorized(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function submit(e) {
    e.preventDefault();
    const res = await fetch(`${serverURL()}/passcode/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ passcode }),
    });
    const data = await res.json();
    if (data.ok) setAuthorized(true);
    else alert("Incorrect passcode.");
  }

  async function logout() {
    await fetch(`${serverURL()}/passcode/auth/logout`, { method: "POST", credentials: "include" });
    setAuthorized(false);
  }

  if (loading || !settings) return null;

  if (!authorized && settings.passcode) {
    return (
      <Maintenance>
        <div className="maintenance-wrapper">
          <IconLogo className="maintenance-logo" />
          <h2>coming soon</h2>
          <form onSubmit={submit}>
            <input type="password" value={passcode} onChange={(e) => setPasscode(e.target.value)} />
          </form>
        </div>
      </Maintenance>
    );
  } else if (settings.passcode) {
    return (
      <MaintenanceButton>
        <button className="maintenance-logout" onClick={logout}>
          Log out
        </button>
        {children}
      </MaintenanceButton>
    );
  }

  return <>{children}</>;
}
